import { render, staticRenderFns } from "./TeacherIntroduceModule.vue?vue&type=template&id=1c36d4cf&scoped=true&"
import script from "./TeacherIntroduceModule.vue?vue&type=script&lang=js&"
export * from "./TeacherIntroduceModule.vue?vue&type=script&lang=js&"
import style0 from "./TeacherIntroduceModule.vue?vue&type=style&index=0&id=1c36d4cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36d4cf",
  null
  
)

export default component.exports